export default {"src":"/_next/static/media/customer-icon.0102e877.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};